<template>
    <div class="BackView">
        <router-link class="BackViewButton" :to="to" v-if="!!to">
            <svg-view name="close"></svg-view>
            <slot></slot>
        </router-link>
        <button class="BackViewButton" @click.prevent="handleClick" v-else>
            <svg-view name="close"></svg-view>
            <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
    name: "BackView",
    props: {
        to: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        handleClick() {
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .BackView;

@{r} {
    position: absolute;
    top: 30px;
    right: 30px;
    transition: opacity .2s ease;

    &:hover {
        opacity: .7;
    }

    &Button {
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        width: 35px;
        height: 35px;
        cursor: pointer;

        svg {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
